<style lang="less" scoped>
.loginBg {
	height: 100vh;
	// background: #000000;
    background: url("~@/assets/img/loginBg.png");
    background-size: cover;
}
.loginMain {
	position: fixed;
	width: 400px;
    left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	border-radius:10px;
}
.formItem {
	position: relative;
	margin: auto;
    background: #E9ECEB;
	input {
		width: 100%;
		outline: none;
		border: none;
		background: #fff;
		padding: 6px 8px;
	}

	label {
        width: 15%;
        font-size: 18px;
	}

    &:first-child {
        padding: 30px 30px 20px;
    }
    &:last-child {
        padding: 0px 30px 30px;
    }
}
.loginBtn {
	padding: 6px 20px;
	display: block;
	width: 100%;
	background: #15123E;
	margin:30px auto;
	text-align:center;
	cursor: pointer;
	user-select: none;
	transition: 0.9s;
    color: #FFF;
	&:hover {
		box-shadow: 0 0 25px  #15123E;
	}
}
.logo {
    width: 60%;
    display: block;
    margin: auto;
}
</style>

<template>
    <div class="loginBg">
		<div class="loginMain">
            <img src="@/assets/img/logo.png" class="logo" alt="">
            <br>
            <div >
                <div class="formItem size16 al">
                    <label >賬號:</label>
                    <input type="text" required="" v-model="user" @keydown.enter="keydown">
                </div>

                <div class="formItem size16 al">
                    <label >密碼:</label>
                    <input type="password" ref="pwd" required="" v-model="pwd" @keydown.enter="login">
                </div>
            </div>
			

			<a class="loginBtn size20 bold op borderMove" @click="login">
                <i></i>
                <i></i>
                <i></i>
                <i></i>
                <span>登錄</span>
            </a>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
            user: "",
            pwd: ""
		}
	},
	methods:{
		login () {
            if (!this.user) {
                this.$Message.warning("請輸入賬號")
            } else if (!this.pwd) {
                this.$Message.warning("請輸入密碼")
            } 
            else {
                let load = this.$Message.loading({
                    content: "登錄中...",
                    duration: 999
                })
                this.$axios({
                    url: "admin/signin",
                    method:"POST",
                    data: {
                        username: this.user,
                        password: this.pwd,
                    }
                }).then(res => {
                    console.log(res)
                    load()
                    if (res.data.data.token) {
                        localStorage.setItem("JWT", res.data.data.token)
                        localStorage.setItem("userId", res.data.data.id)
                        localStorage.setItem("role_id", res.data.data.role_id)
                        this.$store.commit("setState", { key: "role", value: res.data.data.role_id })
                        this.$store.dispatch("initUserInfo")
			            this.$router.push("/index")
                    } 
                    else {
                        this.$Message.warning(res.data.data.msg)
                    }
                }).catch(e => {
                    console.log(e)
                    load()
                    this.$Message.error("網絡錯誤, 請稍後再試")
                })
            }
		},
        keydown () {
            this.$refs.pwd.focus()
        }
	}
}
</script>

